export default "__VITE_ASSET__BJhXVtCn__"